import React, { useState, useEffect } from "react";
import styled from "styled-components";
import whatsapp from "../../assets/images/whatsapp.webp";
import { LuCopyright } from "react-icons/lu";

import {
  IconCopyright,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandYoutube,
  IconMapPin,
  IconPhone,
} from "@tabler/icons-react";
import logo from "../../assets/images/Logo.png";
import facebook from "../../assets/images/facebook.png";
import instagram from "../../assets/images/instagram.png";
import linkedin from "../../assets/images/linkedin.png";
import whatsappS from "../../assets/images/whats-app.png";
import youtube from "../../assets/images/youtube.png";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

// Footer Wrapper
// const FooterWrapper = styled.footer`
//   background-color: #f5f7fa;
//   padding: 2rem 3rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   border-top: 1px solid #e0e0e0;
//   font-family: Arial, sans-serif;

//   @media (max-width: 768px) {
//     flex-direction: column;
//     text-align: center;
//   }
// `;

const FooterWrapper = styled.footer`
  background-color: #f5f7fa;
  // padding: 2rem 3rem;
  font-family: Arial, sans-serif;
  border-bottom: 10px solid black;
`;

// Left Section with contact details
const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 25%;

  @media (max-width: 768px) {
    align-items: center;
    width: 100%;
  }
`;

const LogoImage = styled.img`
  width: 6rem;
  height: auto;
  object-fit: contain;
  margin-bottom: 10px;
`;

// Platform Icons Section
const PlatformItem = styled.div`
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 0.5rem;
  }

  span {
    font-size: 14px;
    margin-left: 0.5rem;
  }
`;

const Termsandservices = styled.div`
  display: flex;
`;
// Links Section (Platform, Company, Resources)
const LinksSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
  margin: 0 10%;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 1rem;
    font-size: 16px;
  }

  a {
    text-decoration: none;
    color: #333;
    margin-bottom: 0.5rem;
    font-size: 14px;

    &:hover {
      color: rgb(167, 140, 76);
    }
  }
`;

// Bottom Section (Copyright and Terms)
const BottomSection = styled.div`
  text-align:center;
  padding-top: 1rem;
   padding-bottom: 1rem;
  border-top: 1px solid rgb(167, 140, 76);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  span {
    font-size: 14px;
  }
`;

// Add this styled component for the social icons
const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 2rem;
  }
`;

const SocialIcon = styled.a`
  color: #333;
  transition: color 0.3s ease;

  &:hover {
    color: rgb(167, 140, 76)!important;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

// Replace the location card styled components with these new ones
const LocationCard = styled.div`
  background-color: transparent;
  width: 240px;

  h4 {
    font-size: 16px;
    margin-bottom: 1rem;
    color: #333;
    font-weight: 600;
    position: relative;
    display: inline-block;

    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 30px;
      height: 2px;
      background-color: rgb(167, 140, 76)!important;
    }
    @media (max-width: 768px) {
      margin-bottom: 0.5rem;
      margin-top: 0rem;
    }  
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: 0.5rem auto;

    h4::after {
      display: none; /* Hide the underline on mobile */
    }
  }
`;


const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const AddressBlock = styled.div`
  margin-bottom: 0.5rem;
  font-size: 13px;

  .location-name {
    font-weight: 600;
    color: #333;
    margin-bottom: 0.3rem;
  }

  .address {
    color: #666;
    line-height: 1.4;
    font-size: 16px;
    margin-bottom: 0.3rem;
  }

  .phone {
    a {
      color: rgb(167, 140, 76)!important;
      text-decoration: none;
      font-size: 12px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
const MapWrapper = styled.div`
  width: 100%;
  height: 350px;
  background: white;
  @media (max-width: 868px) {
    width: 100%;
    height: 400px;
  }
`;

const Footer = () => {
  const navigate = useNavigate();
  // Remove the auto-scroll state and effect
  // const [activeAddress, setActiveAddress] = useState(0);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setActiveAddress((prev) => (prev === 0 ? 1 : 0));
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <FooterWrapper>
      {/* <MapWrapper>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d798.0035800595699!2d55.29604374044558!3d25.24102084301507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43dfcf271a1d%3A0xa95c64131d63078f!2sEmbark%20Properties!5e0!3m2!1sen!2sae!4v1738758484034!5m2!1sen!2sae"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </MapWrapper> */}
      {/* Links Section */}
      <LinksSection>
        <LeftSection>
          <LogoImage src={logo} alt="Logo" />
          <p style={{margin:"0px"}}>
            Embark Properties is a trusted Dubai real estate consultancy offering expert guidance, personalized service, and high-return investment opportunities. We empower buyers and investors to navigate Dubai’s property market with confidence, integrity, and smart strategies.
          </p>
          <SocialLinks>
             <img src={facebook} alt="facebook" 
              style={{ cursor: 'pointer', height: '25px' }}
              onClick={() => window.open('https://www.facebook.com/share/1A6dbUPsPE/?mibextid=wwXIfr', '_blank', 'noopener,noreferrer')}
            />
            <img src={instagram} alt="instagram" 
              style={{ cursor: 'pointer', height: '25px' }}
              onClick={() => window.open('https://www.instagram.com/embark_properties?igsh=em11aWl6YXhpOHh0&utm_source=qr', '_blank', 'noopener,noreferrer')}
            />
            <img src={linkedin} alt="linkedin" 
              style={{ cursor: 'pointer', height: '25px' }}
              onClick={() => window.open('https://linkedin.com/company/embarkproperties', '_blank', 'noopener,noreferrer')}
            />
            <img src={whatsappS} alt="whatsapp" 
              style={{ cursor: 'pointer', height: '25px' }}
              onClick={() => window.open('https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=', '_blank', 'noopener,noreferrer')}
            />
            <img src={youtube} alt="youtube" 
              style={{ cursor: 'pointer', height: '25px' }}
              onClick={() => window.open('https://youtube.com/embarkproperties', '_blank', 'noopener,noreferrer')}
            />
            {/* <SocialIcon
              href="https://www.facebook.com/share/1A6dbUPsPE/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandFacebook />
            </SocialIcon>
            <SocialIcon
              href="https://www.instagram.com/embark_properties?igsh=em11aWl6YXhpOHh0&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandInstagram />
            </SocialIcon>
            <SocialIcon
              href="https://linkedin.com/company/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://youtube.com/embarkproperties"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconBrandYoutube />
            </SocialIcon> */}
          </SocialLinks>
        </LeftSection>

        <LocationCard>
        <LinkGroup>
          <h4>Company Info</h4>
          {/* <Link to="/about">Our Story</Link> */}
          <Link to="/"> Home </Link>
          <Link to="/mortgage"> Mortgage </Link>
          <Link to="/services"> Services </Link>
          <Link to="/projects"> New Launchs </Link>
          <Link to="/team"> Team </Link>
          <Link to="/career"> Career  </Link>
        </LinkGroup>
        </LocationCard>

        <LocationCard>
        <LinkGroup>
          <h4>Information</h4>
          <Link to="/articles"> Market Insights </Link>
          <Link to="/contact">Book an Appointment </Link>
          <Link to="/privacypolicy">Privacy Policy</Link>
        </LinkGroup>
        </LocationCard>

        {(localStorage.getItem("isAuthenticated") === "embark#@1999$33") && (
              <>
                <LocationCard>
                  <LinkGroup>
                    <h4>Admin Link's</h4>
                    <Link to="/uploadarticle"> Add Article  </Link>
                    <Link to="/upload-project"> Add Projects </Link>
                    <Link onClick={() => {
                      localStorage.clear();
                      navigate("/");
                    }}> LogOut </Link>
                  </LinkGroup>
                </LocationCard>
              </>
            )}
        {/* New Location Card Design */}
        <LocationCard>
          <h4>Our Locations</h4>
          <AddressWrapper>
            <AddressBlock>
              <div className="location-name">Dubai</div>
              <div className="address">
                Ali Khalifa Belaisha Building - Office M-02 - 131 Sheikh Rashid
                Rd - Al Karama - Dubai
              </div>
            </AddressBlock>
          </AddressWrapper>
        </LocationCard>
      </LinksSection>

      {/* Bottom Section */}
      <BottomSection>
        <span><LuCopyright /> {new Date().getFullYear()} Embark Properties. All rights reserved.</span>
      </BottomSection>
      <div>
        <img
          onClick={() => {
            window.open(
              "https://api.whatsapp.com/send?phone=+971558000530&text=Hi Embark Properties. I am interested in your services.&source=&data=&app_absent=",
              "_blank"
            );
          }}
          className="fixed-whatsapp"
          src={whatsapp}
        />
      </div>
    </FooterWrapper>
  );
};

export default Footer;
